import React from "react";
import { Button, Card, Modal, Col, Form, Icon, Input, Row, Switch, message, notification, DatePicker, Select } from "antd";

import { connect } from "react-redux";

import {
  deleteCoupon,// fetchCoupon
  fetchCoupons,
  fetchCouponsData
} from "appRedux/actions/Coupons";




class ModalDelete extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false
    }
  }

  showModal = () => {
    this.setState({
      visible: true,
    });
  };



  onNotification = (type, value) => {
    if (type == 'success') {
      notification[type]({
        message: 'Éxito',
        description: 'El vendedor se ha eliminado con éxito.',
      });
    } else {
      notification[type]({
        message: 'Error',
        description: value || 'Ha ocurrido un error al eliminar el vendedor.',
      });
    }
  };


  render() {

    return (
      <div>
        <Button type="danger" onClick={this.showModal}><i className="icon icon-trash" /></Button>
        <Modal
          okText="Borrar"
          cancelText="Salir"
          title="Borrar"
          visible={this.state.visible}
          onOk={() => {
            this.props.deleteCoupon(this.props.recording, () => { this.props.fetchCouponsData(this.props.dataState); });
            this.onNotification('success');
          }}
          onCancel={() => {
            this.props.fetchCouponsData(this.props.dataState);
            this.setState({ visible: false });
          }}
        >
          <p>Está seguro de eliminar el cupón {this.props.recording.name}?</p>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps({ placeStores, categories }) {
  return {
    placeStores,
    categories,
  }
}

export default connect(mapStateToProps, { deleteCoupon, fetchCoupons, fetchCouponsData })(ModalDelete);



// WEBPACK FOOTER //
// ./src/routes/main/Cupons/admin/ModalDelete.js